// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__rflVS","productName":"Table_productName__3QNX8"};